/**
 * Welche Kanäle kann ein Kunde HEUTE wirklich verbinden?
 *
 * DIE EINE QUELLE für jede Kanal-Aussage im Frontend. Fragt
 * `GET /api/public/kanal-verfuegbarkeit` — dieselbe Wahrheit, die auch der Riegel am
 * OAuth-Startpunkt und die §312f-Vertragsbestätigung lesen.
 *
 * WOFÜR (Befund 19.08.2026, §5 UWG)
 * ---------------------------------
 * Die öffentlichen Seiten nannten Kanalzahlen und Kanallisten als feste Texte. Am
 * auffälligsten im Hero der Startseite: ein Produkt-Screenshot mit FÜNF orangefarbenen
 * „Verbinden"-Knöpfen (Facebook, LinkedIn, TikTok, Google Business, Threads), von denen
 * ein zahlender Kunde genau EINEN benutzen kann. Bluesky — der einzige Kanal, der ohne
 * Provider-Freigabe immer funktioniert — kam im Bild gar nicht vor.
 *
 * Warum ein Abruf und keine gepflegte Liste: Eine handgeschriebene Aufzählung ist am
 * Tag der Meta-Freigabe erneut falsch — dann zu KLEIN, und sie verschenkt Umsatz.
 * Diese Antwort wächst von selbst, sobald `CHANNEL_LIVE_FACEBOOK` gesetzt wird.
 *
 * Kein Ratewert bei Fehlern: Bleibt die Antwort aus, gibt der Haken `null` zurück und
 * die Seite zeigt ihren eigenen, zurückhaltenden Ersatztext — nie eine Zahl, die zu
 * groß sein könnte.
 */

import { useEffect, useState } from "react";
import axios from "axios";

export const KANAL_FALLBACK =
  "Welche Kanäle heute direkt verbindbar sind, siehst du nach dem Anmelden unter „Kanäle“.";

export function useKanalVerfuegbarkeit() {
  const [daten, setDaten] = useState(null);

  useEffect(() => {
    let abgebrochen = false;
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/public/kanal-verfuegbarkeit`)
      .then((r) => {
        if (!abgebrochen && r?.data?.satz) setDaten(r.data);
      })
      .catch(() => {});
    return () => {
      abgebrochen = true;
    };
  }, []);

  return {
    /** Fertiger Satz, z. B. „Heute direkt verbindbar: Bluesky und LinkedIn." */
    satz: daten?.satz || null,
    /** Kanalnamen als Liste, oder null wenn unbekannt. */
    frei: daten?.frei || null,
    /** Anzahl, oder null wenn unbekannt. */
    anzahl: typeof daten?.anzahl === "number" ? daten.anzahl : null,
  };
}

export default useKanalVerfuegbarkeit;
